import React from 'react';

import { cn } from '@components/lib/utils';

// A single ring spinner that scales with a `size-*` class and inherits the
// current text color (so it works inside buttons of any tint as well as
// stand-alone loaders). Override size/color via className.
interface SpinnerProps {
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ className }) => (
  <span
    role="status"
    aria-label="Loading"
    className={cn(
      'inline-block size-6 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent',
      className,
    )}
  />
);

export default Spinner;
